import { useTheme } from '@mui/material';
import { useWeaveThemeContext } from '../hocs/ApplicationWrapper/theme';

export const useStyles = () => {
	const muiTheme = useTheme();
	const { theme, isWeaveTheme } = useWeaveThemeContext();

	const svgDataReplaceColor = (
		svgDataUrl: string,
		newColor: string,
		colorToReplace = '#007CA0', //legacy theme primary color
	): string => {
		if (!svgDataUrl) return '';
		if (!newColor) return svgDataUrl;
		// Extract base64 part from data URL
		const base64Data = svgDataUrl.split(',')[1];
		// Decode base64 to get SVG string
		const svgString = atob(base64Data);

		// Parse SVG string to modify
		const parser = new DOMParser();
		const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
		const svgElement = svgDoc.querySelector('svg');

		// Modify fill and stroke attributes for elements and child elements
		const shouldReplace = (el: Element | null, attr: string) =>
			el?.getAttribute(attr)?.toUpperCase() ===
			colorToReplace.toUpperCase();

		const elements = [
			svgElement,
			...Array.from(svgElement?.querySelectorAll('*') ?? []),
		];

		elements.forEach(el => {
			if (shouldReplace(el, 'fill')) {
				el?.setAttribute('fill', newColor);
			}
			if (shouldReplace(el, 'stroke')) {
				el?.setAttribute('stroke', newColor);
			}
		});

		return `data:image/svg+xml;base64,${btoa(svgElement?.outerHTML ?? '')}`;
	};

	return {
		isWeaveTheme,
		selectedTheme: theme,
		themePalette: muiTheme.palette,
		svgDataReplaceColor,
	};
};
